<div class="booble-backdrop-drawer-right">
  <div class="drawer-rtl-in">
    <div class="drawer-content-lg">
      <div class="row padding-left-32 drawer-header">
        <div class="col-md-11">
          <div class="d-flex flex-column">
            <h2 class="title-modal">Confirmar pagamento em massa</h2>
            <p class="p-text-grey-scale-dark mg-bottom-24">Confira as informações para análise do pagamento das ordens
            </p>
          </div>
        </div>

        <div class="col-md-1 d-flex justify-content-end mg-top-10">
          <div (click)="closeModal()" class="close-icon tappable">
            <img src="assets/image/close-modal-icon.svg" />
          </div>
        </div>
      </div>
      <div class="modal-dialog-scrollable-general">
        <div class="modal-body d-flex flex-column h-100">
          <div class="content-container">
            <!-- Top Header -->
            <div class="content-top">
              <span class="orders-count">{{ filteredOrders.length }} {{ filteredOrders.length === 1 ? 'ordem' : 'ordens'
                }} à confirmar</span>
              <div class="search-container">
                <input type="text" placeholder="Pesquisar" class="search-input" [(ngModel)]="searchText"
                  (ngModelChange)="onSearchChange($event)" />
                <img class="search-icon" src="assets/image/search.svg" />
              </div>
            </div>

            <!-- Table Header -->
            <div class="table-header">
              <div class="col-order">Ordem</div>
              <div class="col-client">Cliente</div>
              <div class="col-value">Valor ME</div>
              <div class="col-value">Valor R$</div>
              <div class="col-payment">Valor pago</div>
            </div>

            <!-- Table Rows -->
            <ng-container *ngIf="filteredOrders.length > 0">
              <div *ngFor="let item of filteredOrders" class="table-row-wrapper">
                <div class="table-row">
                  <div class="col-order">
                    <span class="order-id tappable" (click)="goOrderDetail(item.order?.id)">{{ item.order?.id }}</span>
                  </div>
                  <div class="col-client">
                    <span class="client-name">{{ getClientName(item.order) }}</span>
                  </div>
                  <div class="col-value">
                    <div class="value-container">
                      <span class="currency-label">{{ item.order?.currency?.description }}</span>
                      <span class="value-amount">{{ item.order?.amount | amountPipe }}</span>
                    </div>
                  </div>
                  <div class="col-value">
                    <div class="value-container">
                      <span class="currency-label">R$</span>
                      <span class="value-amount">{{ item.order?.quotations[0]?.amountMN | amountPipe }}</span>
                    </div>
                  </div>
                  <div class="col-payment">
                    <div class="radio-group">
                      <label class="radio-option">
                        <input type="radio" [name]="'payment-' + item.order.id" [value]="'integral'"
                          [(ngModel)]="item.paymentType" (ngModelChange)="onPaymentTypeChange(item)" />
                        <span class="radio-custom"></span>
                        <span class="radio-label" [class.active]="item.paymentType === 'integral'">Integral</span>
                      </label>
                      <label class="radio-option">
                        <input type="radio" [name]="'payment-' + item.order.id" [value]="'diferente'"
                          [(ngModel)]="item.paymentType" (ngModelChange)="onPaymentTypeChange(item)" />
                        <span class="radio-custom"></span>
                        <span class="radio-label" [class.active]="item.paymentType === 'diferente'">Diferente</span>
                      </label>
                    </div>
                  </div>
                </div>

                <!-- Expandable section for "diferente" payment type -->
                <div *ngIf="item.paymentType === 'diferente'" class="custom-value-section">
                  <div class="input-wrapper">
                    <mat-form-field class="custom-value-input" appearance="outline">
                      <mat-label>Valor depositado*</mat-label>
                      <input matInput [(ngModel)]="item.customValue" (ngModelChange)="onCustomValueChange(item)"
                        type="text" currencyMask [options]="{
                          prefix: 'BRL ',
                          thousands: '.',
                          decimal: ','
                        }" />
                      <mat-error *ngIf="item.paymentType === 'diferente' && !item.customValue">Valor
                        obrigatório</mat-error>
                    </mat-form-field>
                  </div>

                  <div class="box-amount-quotation">
                    <div class="quotation-content">
                      <span class="label-amount-quotation">O valor pago corresponde à</span>
                      <span class="amount-quotation" [ngClass]="{
                        'positive': item.paymentDifference > 0,
                        'negative': item.paymentDifference < 0
                      }">
                        {{ item.differenceSign }}{{ item.paymentDifference | brl }}
                      </span>
                      <span class="label-amount-quotation">do valor cotado</span>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>

            <!-- Empty State -->
            <ng-container *ngIf="filteredOrders.length === 0">
              <div class="empty-state">
                <span class="grey-text">Nenhuma ordem encontrada.</span>
              </div>
            </ng-container>
          </div>
          <div class="spacer"></div>
          <!--   <div class="footer-actions">
            <button type="button" class="btn-cancel" (click)="closeModal()">Cancelar</button>
            <button type="button" class="btn-confirm" (click)="confirmPayments()"
              [disabled]="filteredOrders.length === 0 || loading">
              <span *ngIf="loading" class="spinner-border spinner-border-sm mr-2"></span>
              Confirmar pagamento
            </button>
          </div> -->

        </div>
        <div class="modal-footer-new" [style.justify-content]="'space-between'">
          <button type="button" [style.width]="'134px'" class="btn-outline-dark btn" (click)="closeModal()"
            type="button">
            Fechar
          </button>
          <button type="button" class="btn-footer btn btn-dark-primary-blue"
            [disabled]="filteredOrders.length === 0 || loading" (click)="confirmPayments()" type="button">
            Confirmar
            <span class="spinner-border spinner-border-sm" *ngIf="loading"></span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>